import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useConfirmTokenPurchaseMutation } from "../../redux/slices/paymentApiSlice";
import { Box } from "@mui/material";
import { CustomLoader } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../../redux/slices/authSlice";

const TokenPurchaseSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [confirmPurchase, { isLoading: confirming }] = useConfirmTokenPurchaseMutation();
  const dispatch = useDispatch();
const { userInfo, accessToken } = useSelector((state) => state.auth);
  useEffect(() => {
    const confirm = async () => {
      const sessionId = searchParams.get("checkout_session_id");
      console.log("Retrieved sessionId:", sessionId); // Debugging line
      if (!sessionId) {
        toast.error("Session ID invalide");
        navigate("/dashboard");
        return;
      }

      const res = await confirmPurchase({ session_id: sessionId });

      if (res?.data?.status === 200) {
      
        dispatch(
          setCredentials({
            accessToken,
            userInfo: {
              ...userInfo,
              seo_non_perishing: res?.data?.seo_non_perishing,
            },
          })
        );
        toast.success(res?.data?.message || "Achat confirmé !");
      } else {
        toast.error("Session ID invalide ou erreur de confirmation.");
      }

      navigate("/dashboard");
    };

    confirm();
  }, [searchParams, confirmPurchase, navigate]);

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        height={"50vh"}
      >
        <CustomLoader />
      </Box>
    </>
  );
};

export default TokenPurchaseSuccess;